export function BackgroundGrid({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={`bg-grid bg-grid-drift pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_top,black,transparent_75%)] ${className}`}
    />
  );
}
